import { render, staticRenderFns } from "./public-posting-label.vue?vue&type=template&id=96654392&"
import script from "./public-posting-label.vue?vue&type=script&lang=js&"
export * from "./public-posting-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports